import { AuthService } from "../services/authentication.service";

export function handleResponse(response: any) {
    return response.text().then((text: string) => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if ([401, 403].indexOf(response.status) !== -1) {
                // auto logout if 401 Unauthorized or 403 Forbidden response returned from api                
                AuthService.logout();
                document.location.reload(true);
            }

            const error = (data && data.join(', ')) || response.statusText;
            return Promise.reject(error);
        }

        return data;
    });
}